__turbopack_context__.v({
  "desktop": "AImage-module-scss-module__bV7IPG__desktop",
  "desktop-is-background": "AImage-module-scss-module__bV7IPG__desktop-is-background",
  "mobile-is-background": "AImage-module-scss-module__bV7IPG__mobile-is-background",
  "mobile-is-hidden-on-desktop": "AImage-module-scss-module__bV7IPG__mobile-is-hidden-on-desktop",
  "placeholder": "AImage-module-scss-module__bV7IPG__placeholder",
});
